import { createFileRoute } from "@tanstack/react-router";
import { Closes } from "@/components/Closes";

function RouteComponent() {
  return <Closes />;
}

export const Route = createFileRoute("/_authenticated/closes/")({
  component: RouteComponent,
  staticData: { page: "closes" },
});
